import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'names_of_organizations_providing_contract_workers_not_part_of_the_production_process'

export const dataPointDefinition = {
  retracedId: 'names_of_organizations_providing_contract_workers_not_part_of_the_production_process',
  name: 'List the names of all organizations providing contract workers who are not part of the production process, and the services provided by each (e.g., security or cleaning services):',
  description:
    'Agency/contract workers are under contract with an organization other than the facility to work at the facility.',
  meta: {},
  fieldTypeId: 'LONG_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-wor-13f',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1310,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
